export namespace TenantActions {
  export class GetTenant {
    static readonly type = "[TENANT] Get tenant";
  }
}
